import type { ReactNode } from 'react';
import React from 'react';
/** @jsx jsx */
// External libraries
// @ts-expect-error - untyped import
import { LoadingSpinner } from '@checkout/react-components';
import {
  CacheProvider as CacheProviderLegacy,
  css,
  Global,
  jsx,
} from '@emotion/core';

import { CacheProvider } from '@emotion/react';

// Internal modules
import { getContent, getGlobals } from '@/lib';
import { globalStyles, resetStyles } from '@/styles';
import { StyledText } from '../Common';
import {
  EMOTION_CACHE,
  getEmotionCacheKey,
  LEGACY_EMOTION_CACHE,
} from './constants';
import {
  MerchantLogo as Logo,
  MerchantLogoContainer,
  ValuePropContainer,
  // @ts-expect-error - convert to TS after c3 is removed
} from './StyledComponents';
import { valuePropHeaderStyles, valuePropSubHeaderStyles } from './styles';
import { ShieldImage } from '../Common/Images';
import type { GenericObjectType } from '@/types';

const EmotionWrapper = ({
  pageName,
  children,
}: {
  pageName?: string;
  children: ReactNode;
}): JSX.Element => {
  /*
    While migrating from Emotion 10 to 11 we will need to support two versions
    of Emotion cache. Once the migration is complete we should remove
    references to the legacy cache
  */
  const cacheKey = getEmotionCacheKey();

  return (
    <CacheProviderLegacy value={LEGACY_EMOTION_CACHE[cacheKey]}>
      <CacheProvider value={EMOTION_CACHE[cacheKey]}>
        <Global styles={[resetStyles, globalStyles]} />
        {children}
      </CacheProvider>
    </CacheProviderLegacy>
  );
};

const PageLoadingSpinner = (props: GenericObjectType): JSX.Element => (
  <LoadingSpinner
    overlayStyleOverrides={css({ backgroundColor: '#fff' })}
    {...props}
  />
);

const PayPalValueProps = (): JSX.Element => (
  <ValuePropContainer>
    <ShieldImage
      ariaDescribedByContent={getContent('accessibility.shield.alt')}
    />
    <StyledText css={valuePropHeaderStyles}>
      {getContent('valueProps.image.header')}
    </StyledText>
    <StyledText css={valuePropSubHeaderStyles}>
      {getContent('valueProps.image.subHeader')}
    </StyledText>
  </ValuePropContainer>
);

const MerchantLogo = (): JSX.Element | null => {
  const { initialGqlData } = getGlobals();
  const merchantlogo =
    initialGqlData?.checkoutSession?.merchant?.logo?.href || '';

  if (!merchantlogo) {
    return null;
  }

  return (
    <MerchantLogoContainer data-testid="merchantlogo">
      <Logo src={merchantlogo} />
    </MerchantLogoContainer>
  );
};

export { EmotionWrapper, MerchantLogo, PageLoadingSpinner, PayPalValueProps };
